<template>
  <div class="apps-selector">
    <h3 class="h3">
      Apps access policy
    </h3>
    <div class="node-form__tags tags">
      <div>
        <md-radio
          v-model="mode"
          value="common"
          class="md-primary"
          @change="modeChanged(mode)"
        >
          Common
        </md-radio>
        <md-radio
          v-model="mode"
          value="blacklist"
          @change="modeChanged(mode)"
        >
          Blacklist
        </md-radio>
        <md-radio
          v-model="mode"
          value="whitelist"
          class="md-primary"
          @change="modeChanged(mode)"
        >
          Whitelist
        </md-radio>
      </div>

      <grouped-auto-complete
        v-if="mode !== 'common'"
        :groups="groupedApps"
        :selected="selectedApps.map(a => a.app_identity)"
        @list-updated="updateList"
      />

      <p v-if="mode==='blacklist'">
        Enable all apps except:
      </p>
      <p v-if="mode==='whitelist'">
        Disable all apps except:
      </p>

      <md-chip
        v-for="appName in selectedApps"
        :key="appName.app_identity"
        class="md-primary"
        md-deletable
        @md-delete="deleteChip(appName)"
      >
        {{ appName.app_identity }}
        <button @click="onVersionClick(appName)">
          {{ appName.app_version === '0.0.0' ? 'for all versions' : `since ${appName.app_version}` }}
        </button>
      </md-chip>
    </div>

    <md-dialog-prompt
      v-model="versionDialog.model"
      :md-active.sync="versionDialog.isOpen"
      md-title="App version?"
      md-input-placeholder="0.0.0"
      md-confirm-text="Update"
      @md-confirm="onVersionDialogSubmit"
    />
  </div>
</template>
<script>
import semver from "semver";
import GroupedAutoComplete from "@/components/Forms/Fields/GroupedAutoComplete";

export default {
  name: "AppsSelector",
  components: {
      GroupedAutoComplete
  },
  props: {
    "initial-mode": { type: String, required: true },
    "initial-apps": { type: Array, required: true }
  },
  data() {
    return {
      mode: "common",
      apps: [],
      selectedApp: "",
      selectedApps: [],

      groupedApps: {},

      versionDialog: {
          isOpen: false,
          model: "",
          appIdentity: ""
      }
    };
  },
  watch: {
    "initialMode": "updateFromProps",
    "initialApps": "updateFromProps",
  },
  mounted() {
    this.fetchApps();

    // if props are passed, use them as the initial state
    if (this.$props.initialMode || this.$props.initialApps) {
      this.updateFromProps();
    }
  },
  methods: {
    modeChanged() {
      this.$emit("appsModeChanged", this.mode);
    },
    updateList(newList) {
      this.selectedApps = newList.map(i => {
          const currentApp = this.selectedApps.find(app => i === app.app_identity);
          if (currentApp) {
              return currentApp;
          } else {
              return { app_identity: i, app_version: "0.0.0" };
          }
      });

      this.selectedApp = "";

      this.$emit("appsListChanged", this.selectedApps);
    },
    deleteChip(cname) {
      this.selectedApps = this.selectedApps.filter(el => {
        return el !== cname;
      });

      this.$emit("appsListChanged", this.selectedApps);
    },
    fetchApps() {
      this.$http.get("/v1/admin/store/apps").then(res => {
        this.apps = res.data.apps.map(a => a.identity);

        const groupedApps = {};

        groupedApps.assguard = this.apps.filter(app => !app.includes("clearvpn"));
        groupedApps.clear = this.apps.filter(app => app.includes("clearvpn"));

        this.groupedApps = groupedApps;
      });
    },
    updateFromProps() {
      this.mode =  this.$props.initialMode || "common";
      this.selectedApps = this.$props.initialApps || [];
    },

    onVersionClick(appName) {
      this.versionDialog = {
        isOpen: true,
        model: appName.app_version,
        appIdentity: appName.app_identity
      };
    },
    onVersionDialogSubmit() {
      if (!semver.valid(this.versionDialog.model)) {
          this.versionDialog = {
              ...this.versionDialog,
              isOpen: true,
              model: "",
          };
          this.$notify({
              group: "foo",
              title: "Invalid version",
          });
          return;
      }

      this.selectedApps = this.selectedApps.map(a => {
          if (a.app_identity === this.versionDialog.appIdentity) {
              return {
                  app_identity: this.versionDialog.appIdentity,
                  app_version: this.versionDialog.model
              };
          } else {
              return a;
          }
      });

      this.$emit("appsListChanged", this.selectedApps);
      this.versionDialog = {
          isOpen: false,
          model: "",
          appIdentity: ""
      };
    }
  }
};
</script>
